import CodeMirrorEditor from "./CodeMirrorEditor";

CodeMirrorEditor.install = (Vue) => { Vue.component("CodeMirrorEditor", CodeMirrorEditor) }

export default CodeMirrorEditor;
